<template>
    <b-popover
        ref="popover"
        :target="target"
        triggers="hover blur"
        title="Reservation"
        custom-class="reservation-preview"
    >
        <preview
            :details="details"
            :providers="providers"
            @details-loaded="detailsLoaded"
        />
        <footer class="card-footer">
            <preview-footer
                @edit="$emit('edit', details)"
                @checkin="$emit('checkin', details)"
                @checkout="$emit('checkout', details.id)"
                @undo="$emit('undo', details.id)"
                @cagecard="$emit('cagecard', details.id)"
                @split="$emit('split', details.id)"
                @cancel="$emit('cancel', details.id)"
                @extend="$emit('extend', details.id)"
                :status="details.status"
                :boarding="boarding"
            />
        </footer>
    </b-popover>
</template>

<script>
import Preview from "./reservation-preview.vue";
import PreviewFooter from "./reservation-preview-footer.vue";

export default {
    components: {
        Preview,
        PreviewFooter
    },
    data() {
        return {
            boarding: null
        };
    },
    props: {
        details: {
            type: Object
        },
        target: {
            type: String
        },
        providers: {
            type: Array
        }
    },
    methods: {
        detailsLoaded(boarding) {
            this.boarding = boarding;
        }
    }
};
</script>

<style scoped>
.b-popover.reservation-preview {
    min-width: 550px;
    width: 550px;
}
::v-deep .popover-body {
    padding: 0;
}
::v-deep .custom-flex .bv-no-focus-ring {
    display: flex;
    align-items: center;
}
::v-deep h3.popover-header {
    font-size: 0.85rem;
}
</style>
